<template>
<div>
  <section class="content-header">
    <h1>{{$t('contact_type.list')}}</h1>
  </section>

  <section class="content">
    <div class="box box-primary">
      <div class="box-header with-border">
        <router-link :to="{ name: 'ContactTypeCreate' }" class="btn btn-primary pull-right">{{$t('contact_type.add')}}</router-link>
      </div>
      <div class="box-body">
        <item-list-errors :entity="'contact_type'"></item-list-errors>

        <api-table
                :entity="'ContactType'"
                :route="'contact_types'"
                :path="'contact_type'"
                :filterable="filterable"
                :sortable="sortable"
                :columns="columns"
        ></api-table>
      </div>
    </div>
  </section>
</div>
</template>

<script>
import ItemListErrors from '../layout/errors/ItemListErrors'
import ApiTable from '../ApiTable'

export default {
  components: {ItemListErrors, ApiTable},
  data: function () {
    return {
      columns: ['id', 'name', 'actions'],
      filterable: ['id', 'name'],
      sortable: ['id', 'name'],
    }
  },
}
</script>



// WEBPACK FOOTER //
// src/components/contact_type/List.vue